import { render, staticRenderFns } from "./drinksManage.vue?vue&type=template&id=94dd8afc&"
import script from "./drinksManage.vue?vue&type=script&lang=js&"
export * from "./drinksManage.vue?vue&type=script&lang=js&"
import style0 from "./drinksManage.vue?vue&type=style&index=0&id=94dd8afc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports